
import { Options, Vue } from "vue-class-component";
import Turret from "@/entities/Turret";
import Card from "@/components/common/Card.vue";
import TurretContract from "@/components/turret/contracts/TurretContract.vue";
import { getTurret } from "@/services/turret/turret";
import AppButton from "@/components/common/AppButton.vue";

@Options({
  components: { AppButton, TurretContract, Card },
  emits: ["loaded"],
})
export default class TurretForm extends Vue {
  private turretUrl =
    "https://stellar-turrets-testnet.sdf-ecosystem.workers.dev";
  private turret = Turret.createNull();
  private showDetails = false;
  private isLoading = false;

  async loadTurret(): Promise<void> {
    this.isLoading = true;
    this.turret = await getTurret(this.turretUrl);
    this.$emit("loaded", this.turret);
    this.isLoading = false;
  }
}
